import styles from './InputConfirmIcon.module.scss'
export const InputConfirmIcon = (status)=>{
  const {iconOk, iconError} = styles;
  if(status){
    return (
      <span className={iconOk}>
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 3.33642L2.842 5.17842C2.92628 5.2627 3.06512 5.25501 3.13959 5.16193L6.46914 1" stroke="#00B67A" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      </span>
    );
  } else {
    return (
      <span className={iconError}>
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 6.5L6.5 1.5" stroke="#FF6960" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M6.5 6.5L1.5 1.5" stroke="#FF6960" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
       </span>
    );
  }
}